<template lang="pug">
  div
    active-item
      .dropdown(:class="{active: active}" slot-scope="{ setActive, active }" v-click-outside="() => setActive(false)")
        .dropdown__btn(@click.prevent="setActive(!active)")
          span(class="align-middle leading-10") {{ label }}
          mark(class="inline-flex items-center justify-center md:hidden ml-2")
            | 1
        fade-transition
          .dropdown__menu(class="px-16 pt-10 pb-12 md:min-w-350p" v-show="active")
              div(class="mb-8")
                | Quel est votre budget ?
              .pb-10
                rental-range(
                  v-if="isRental"
                  :initial-rent-min="searchParams.by_min_rent"
                  :initial-rent-max="searchParams.by_max_rent"
                  @updated="(budgetizeLabel) => { label = budgetizeLabel }"
                )

                price-range(
                  v-else
                  :initial-budget-min="searchParams.by_min_price"
                  :initial-budget-max="searchParams.by_max_price"
                  @updated="(budgetizeLabel) => { label = budgetizeLabel }"
                )
</template>

<script>
import PriceRange from '@components/Searchbar/PriceRange'
import RentalRange from '@components/Searchbar/RentalRange'

export default {
  components: {
    PriceRange,
    RentalRange
  },

  props: {
    searchParams: {
      type: Object,
      required: true
    },

    isRental: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      label: 'Budget'
    }
  }
}
</script>
